import { ThisReceiver } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EHealthInsurabilityDialogComponent } from 'src/app/dialogs/e-health/e-health-assurability-dialog/e-health-assurability-dialog.component';
import { EHealthDmgDialogComponent } from 'src/app/dialogs/e-health/e-health-dmg-dialog/e-health-dmg-dialog.component';
import { EHealthTransactionDialogComponent } from 'src/app/dialogs/e-health/e-health-transaction-dialog/e-health-transaction-dialog.component';
import { CNPatient } from 'src/app/models/cnpatient';
import { EHealthService } from 'src/app/services/e-health.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-patientehealthinfo',
  templateUrl: './patientehealthinfo.component.html',
  styleUrls: ['./patientehealthinfo.component.scss']
})
export class PatientEHealthInfoComponent implements OnInit {

  public insurabilityDiffers = false;

  constructor(public ehealth: EHealthService, public patient: PatientService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.patient.patientSelectedEvent.subscribe(patientselected => {
      this.ehealth.patientconsent(patientselected.id).subscribe();
      this.ehealth.patientdmg(patientselected.id).subscribe();
      this.ehealth.patienttherlink(patientselected.id).subscribe();
      this.ehealth.patientinsurability(patientselected.id).subscribe(result => {
        this.insurabilityDiffers = false;
        const regime = this.ehealth.insurability.ct1 + '/' + this.ehealth.insurability.ct2;
        if (regime !== patientselected.getProperty('Regime') || patientselected.insurance.code !== this.ehealth.insurability.mutuality) {
          this.insurabilityDiffers = true;
        }
      });
      this.ehealth.patienttransactionlist(patientselected.id).subscribe();
      this.ehealth.patienttherlinks(patientselected.id).subscribe();
      patientselected.updated.subscribe(patientupdated => {
        const updatedpatient = patientupdated as CNPatient;
        this.insurabilityDiffers = false;
        const regime = this.ehealth.insurability.ct1 + '/' + this.ehealth.insurability.ct2;
        if (regime !== updatedpatient.getProperty('Regime') || updatedpatient.insurance.code !== this.ehealth.insurability.mutuality) {
          this.insurabilityDiffers = true;
        }
      });
    });
  }

  showHubTransactionsClick() {
      let dialogRef = this.dialog.open(EHealthTransactionDialogComponent, {
          data: {},
          minWidth: '75%'
      });
      dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
      });
  }

  showInsurability() {
    const dialogRef = this.dialog.open(EHealthInsurabilityDialogComponent, {
      data: {
        insurability: this.ehealth.insurability
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showDMG() {
    // View content
    const dialogRef = this.dialog.open(EHealthDmgDialogComponent, {
      data: {
        dmg: this.ehealth.dmg.result
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
